import { defineComponent } from 'vue';
import { Image2 } from '@hems/component';
export default defineComponent({
    name: 'ApplianceItem',
    components: {
        Image2,
    },
    props: {
        imageName: {
            type: String,
            default: null,
        },
        applianceName: {
            type: String,
            default: null,
        },
        onOffStatus: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
    },
});
